

import {$idSeed} from "@util/util.js";
import DomHelper from "@util/DomHelper.js";

export default class Observer{
    constructor(dom, type,firstClass,lastClass){
        this._id = $idSeed.newId();

        this._dom = dom;
        this._type = type;
        this._firstClass = firstClass;
        this._lastClass = lastClass;
    }
    //此处需要改良，如何处理Class变更的问题
    onUpdate(value){
        if(!this._type){
            DomHelper.setValue(this._dom, value);
        }else{
            if(this._type == "ck"){
                value?this._dom.addClass("icon-checked").removeClass("icon-uncheck"):this._dom.addClass("icon-uncheck").removeClass("icon-checked");
            }
            if(this._type == "show"){
                value?$(this._dom).show():$(this._dom.hide());
            }
            if(this._type == "cls"){
                if(this._firstClass != ""){
                    value?this._dom.addClass(this._firstClass):this._dom.removeClass(this._firstClass);
                }
                if(this._lastClass != ""){
                    value?this._dom.removeClass(this._lastClass):this._dom.addClass(this._lastClass);
                }
            }
        }
    }
}